<!--toggle: bg-white|bg-primary|bg-info|bg-warning|bg-dark|bg-success|bg-danger|bg-secondary------>
<header class="app-header navbar bg-white"> <!--when dark-blue theme is called bg-dark class will apply-->
  <!-- <a class="navbar-brand" href="#url"><img src="../../../assets/brand/logo-high-dark.jpg" /></a> -->
  <button id="left-toggle" type="button" class="navbar-toggler" (click)="toggle()"><span class="navbar-toggler-icon"></span></button> <!--d-lg-block d-none-->

  <ul class="nav navbar-nav d-md-down-none mr-auto">
    <li class="nav-item"><a class="nav-link" style="padding-left:5px;">{{common.pageTitle ? common.pageTitle: ''}}</a></li>  <!--{{common.pageTitle ? common.pageTitle: ''}}-->
  </ul>


 <!------Right side menu.--------->  
  <ul class="nav navbar-nav ml-auto right-menu-option" style="display:none;">
      <!-- <li class="nav-item d-md-down-none">
          <a class="nav-link" href="#">DDF</a>
      </li> -->
      <!-- <li class="nav-item dropdown notification-bell">
          <a class="text-decoration-none dropdown-toggle"  href="javascript:void(0);">
            <span class="bell-icon"><i class="fa far fa-bell" style="font-size: 20px;"></i></span>
            <span class="badge badge-primary">99+</span>
          </a>
          <div class="dropdown-menu text-small">
              <div class="dropdown-header">
                  <h4 class="noti-title">Notification</h4>
                  <a class="clear-all" href="javascript:void(0);">Clear All</a>
              </div>
              <div class="dropdown-body">
                  <ul class="timeline">
                      <li>
                          <div class="message-icon-img">
                            <span>
                                <img class="img-fluid" src="../../../assets/img/avatars/9.jpg" />
                            </span>
                          </div>
                          <div class="message-body">
                                <h4>Cristina Pride</h4>
                                <p class="text-muted mb-0"><small>Hi, How are you? What about our next meeting</small></p>
                          </div>
                      </li>
                      <li>
                        <div class="message-icon-img">
                          <span><i class="fa far fa-bell"></i></span>
                        </div>
                        <div class="message-body">
                              <h4>Caleb Flakelar commented on Admin</h4>
                              <p class="text-muted mb-0"><small>Hi, How are you? What about our next meeting</small></p>
                        </div>
                      </li>
                      <li>
                        <div class="message-icon-img">
                          <span><i class="fa far fa-bell"></i></span>
                        </div>
                        <div class="message-body">
                          <h4>Caleb Flakelar commented on Admin</h4>
                          <p class="text-muted mb-0"><small>Hi, How are you? What about our next meeting</small></p>
                        </div>
                      </li>
                      <li>
                        <div class="message-icon-img">
                          <span><i class="fa far fa-bell"></i></span>
                        </div>
                        <div class="message-body">
                            <h4>Caleb Flakelar commented on Admin</h4>
                            <p class="text-muted mb-0"><small>Hi, How are you? What about our next meeting</small></p>
                        </div>
                      </li>
                  </ul>
              </div>
              <div class="dropdown-footer">
                  <a class="view-all-link" href="javascript:void(0);">View All <i class="far fa-arrow-alt-circle-right"></i></a>
              </div>
          </div>
      </li> -->
  </ul>

  <!--new-->
  <!-- <div class="notification-bell-dropdown mr-2" ngbDropdown>
    <button class="btn" id="notification" ngbDropdownToggle>
      <span class="bell-icon"><i class="fa far fa-bell" style="font-size: 20px;"></i></span>
      <span class="badge badge-primary">99+</span>
    </button>
    <div class="dropdown-submenu noti-submenu" ngbDropdownMenu="notification">
        <div class="dropdown-header noti-title">
           <h4 class="noti-title-h4">Notification</h4>
           <a class="clear-all" href="javascript:void(0);">Clear All</a>
        </div>
        <div class="dropdown-body">
           <ul class="timeline">
              <li>
                  <div class="message-icon-img">
                    <span>
                        <img class="img-fluid" src="../../../assets/img/avatars/9.jpg" />
                    </span>
                  </div>
                  <div class="message-body">
                        <h4>Cristina Pride</h4>
                        <p class="text-muted mb-0"><small>Hi, How are you? What about our next meeting</small></p>
                  </div>
              </li>
              <li>
                <div class="message-icon-img">
                  <span><i class="fa far fa-bell"></i></span>
                </div>
                <div class="message-body">
                      <h4>Caleb Flakelar commented on Admin</h4>
                      <p class="text-muted mb-0"><small>Hi, How are you? What about our next meeting</small></p>
                </div>
              </li>
              <li>
                <div class="message-icon-img">
                  <span><i class="fa far fa-bell"></i></span>
                </div>
                <div class="message-body">
                  <h4>Caleb Flakelar commented on Admin</h4>
                  <p class="text-muted mb-0"><small>Hi, How are you? What about our next meeting</small></p>
                </div>
              </li>
              <li>
                <div class="message-icon-img">
                  <span><i class="fa far fa-bell"></i></span>
                </div>
                <div class="message-body">
                    <h4>Caleb Flakelar commented on Admin</h4>
                    <p class="text-muted mb-0"><small>Hi, How are you? What about our next meeting</small></p>
                </div>
              </li>
           </ul>
        </div>
        <div class="dropdown-footer">
           <a class="view-all-link" href="javascript:void(0);">View All <i class="far fa-arrow-alt-circle-right"></i></a>
        </div>
    </div>
  </div> -->

  <div class="user-login-name-dropdown ml-2" ngbDropdown>
    <button class="btn" id="userloginname" ngbDropdownToggle>
      <!-- <img src="https://github.com/mdo.png" alt="mdo" width="25" height="25" class="img-avatar mr-1 rounded-circle"> -->
      <span class="initial-user-name">{{userName.charAt(0) }}</span>
      <!-- + userName.charAt(1)  -->
      <span style="padding:0px 5px;">{{userName}}</span>
      
      <!-- <span style="padding: 0px 5px;">
        {{ userName }}
        <sub style="padding-left: 5px;">{{+role }}</sub>
      </span> -->
    </button>
    <div class="dropdown-submenu" ngbDropdownMenu="userloginname">
      <div class="dropdown-header noti-title">
        <h6 class="text-overflow m-0">Welcome !</h6>
      </div>
      <button class="sub-menu" ngbDropdownItem routerLink="/profile" style="display: none;"><i class="fa far fa-user mr-1"></i> My Account</button>
      <button class="sub-menu" ngbDropdownItem style="display: none;"><i class="fa fas fa-unlock-alt mr-1"></i> Change Password</button>
      <button class="sub-menu" ngbDropdownItem (click)="logout()"><i class="fa fas fa-sign-out-alt mr-1"></i> Sign out</button>  <!--(click)="logout()"-->
    </div>
  </div>
  <!------Right side menu.--------->

  <!--<button id="right-toggle" type="button" class="navbar-toggler right-toggler"><span class="fa fas fa-palette"></span></button>d-lg-block d-none-->

</header>

